import useApplicationState from './useApplicationState';
import { useCallback } from 'react';

var useTileLoader = () => {
  var {
    apiKey,
    onTileLoadError
  } = useApplicationState();
  return useCallback((tile, src) => {
    if (apiKey) {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', src);
      xhr.setRequestHeader('X-API-Key', apiKey);
      xhr.responseType = 'arraybuffer';
      xhr.addEventListener('load', function () {
        var arrayBufferView = new Uint8Array(this.response);
        var blob = new Blob([arrayBufferView], {
          type: 'image/png'
        });
        var urlCreator = window.URL || window.webkitURL;
        var imageUrl = urlCreator.createObjectURL(blob);
        tile.getImage().src = imageUrl;
      });
      xhr.addEventListener('error', function (e) {
        onTileLoadError === null || onTileLoadError === void 0 ? void 0 : onTileLoadError(e);
      });
      xhr.send();
    }
  }, [apiKey, onTileLoadError]);
};

export default useTileLoader;